import Raven from 'raven-js';
import initData from 'init-data';
const sampleRate = 20;

window.Raven = Raven;

const _errorShouldBeIgnored = errorMsg => {
    let errorsToIgnore = [
        'top.GLOBALS',
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        "Can't find variable: ZiteReader",
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        'fb_xd_fragment',
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        'conduitPage',
        'atomicFindClose',
        'measurePositions is not defined',
        'DealPly is not defined',
        'ReferenceError: Components is not defined',
        'Uncaught ReferenceError: Moses is not defined',
        'find variable: dataKeys',
        'ReferenceError: Can"t find variable: __init14',
        'ReferenceError: Can"t find variable: __initialized',
        'SyntaxError: Expected an identifier but found "endingLogEvents" instead',
        'egenskapen xId',
        'Unable to get property "xId" of undefined or null reference',
        'metrics',
        'Generic use of __proto__',
        'Script error',
        'NS_ERROR',
        'nodejs',
        'utm',
        'UET',
        'transport is null',
        'Identifierare f',
        'jload',
        'Unknown error',
        'egenskapen payload',
        'find variable: SelectedDivWithSearchText',
        'Unable to get value of the property "close": object is null or undefined',
        'Unable to get value of the property "onClose": object is null or undefined',
        'Unable to get value of the property "packet": object is null or undefined',
        'Unable to get property "close" of undefined or null reference',
        'Unable to get property "payload" of undefined or null reference',
        'Uncaught TypeError: Cannot read property "packet" of null',
        'Uncaught TypeError: Cannot read property "onClose" of null',
        'Cannot read property "payload" of null',
        'egenskapen close: objektet',
        'egenskapen packet: objektet',
        'InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable',
        'this.transport',
        'Cannot read property "close" of null',
        'Uncaught TypeError: Cannot call method "close" of null',
        'egenskapen onClose: objektet',
        'mta egenskapen close',
        'Unable to get value of the property "payload": object is null or undefined',
        'mta egenskapen packet',
        'mta egenskapen onClose',
        'Unable to get property "onClose" of undefined or null reference',
        'Uncaught TypeError: Cannot call method "onClose" of null',
        'Uncaught TypeError: Cannot call method "payload" of null',
        'Uncaught InvalidStateError: Failed to execute "send" on "WebSocket"',
        'Blocked a frame with origin',
        'inscreenElement.getBoundingClientRect',
        'isInscreen',
        'app-data',
        'variable: fieldset',
        'ormmaview',
        'googletag',
        'NS_ERROR',
        'NS_ERROR_UNEXPECTED',
        'NS_ERROR_NOT_CONNECTED',
        'NS_ERROR_FAILURE',
        'TypeError: this.transport is null',
        '.transport is null',
        'onScriptComplete',
        'Loading chunk',
        'avastBHO',
        'BurstingPipe',
        'Uncaught TypeError: Generic use of __proto__ accessor not allowed'
    ];

    return errorsToIgnore.includes(errorMsg.toString());
};

const shouldSend = data => {
    if (
        'navigator' in window &&
        /(P|p)hantom/.test(window.navigator.userAgent)
    ) {
        return false;
    }

    // If is logged in
    if (initData) {
        if (initData.isLoggedIn) {
            Raven.setUserContext({
                id: initData.memberId
            });
            Raven.setExtraContext({
                loggedIn: true
            });
        }
        if (initData.isHybridAppContext) {
            Raven.setExtraContext({
                isHybridAppContext: true
            });
        }
        if (initData.isNativeAppContext) {
            Raven.setExtraContext({
                isNativeAppContext: true
            });
        }
    }

    let shouldSend = Math.random() * 100 <= sampleRate;
    return data && shouldSend && !_errorShouldBeIgnored(data.toString());
};

const setup = () => {
    if (process && process.env && process.env.NODE_ENV === 'production') {
        window.onunhandledrejection = function(evt) {
            Raven.captureException(evt.reason);
        };
        try {
            Raven.config(
                'https://aded37c82da24c40b403e8790998c27d@sentry.io/143263',
                {
                    environment: window.location.host,
                    includePaths: [
                        /se1-testnginximg-01\.intranet\.tradera\.com/,
                        /(http|https):\/\/(www\.|beta-a\.|beta-b\.|beta-c\.)tradera\.(com|se)/,
                        /https:\/\/static\.tradera\.net/,
                        /http:\/\/static\.tradera\.net/,
                        /\/\/static\.tradera\.net/,
                        /http?:\/\/se1-testnginximg-01\.intranet\.tradera\.com/,
                        /http:\/\/10\.211\.55\.3:5454/
                    ],
                    ignoreUrls: [
                        /graph\.facebook\.com/i,
                        /connect\.facebook\.net\/en_US\/all\.js/i,
                        /pixelsafe\.adsafeprotected.com/,
                        /gstatic/,
                        /extensions\//i,
                        /^chrome:\/\//i,
                        /gpt/i,
                        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
                    ],
                    shouldSendCallback: shouldSend,
                    autoBreadcrumbs: true,
                    maxBreadcrumbs: 25,
                    debug: true
                }
            ).install();
            Raven.setRelease(window.releaseVersion);
        } catch (e) {
            console.error(e);
        }
    }
};

setup();



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/sentry.js